"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var AddButton_1 = __importDefault(require("../../../common/buttons/AddButton"));
var edit_icon_svg_1 = __importDefault(require("res/img/edit-icon.svg"));
var edit_icon_dark_svg_1 = __importDefault(require("res/img/edit-icon-dark.svg"));
var close_icon_svg_1 = __importDefault(require("res/img/close-icon.svg"));
var EditProductSpecificationItems = function (_a) {
    var items = _a.items, editing = _a.editing, onSetEdit = _a.onSetEdit, onEdit = _a.onEdit, onDelete = _a.onDelete, onSubmit = _a.onSubmit, products = _a.products;
    var _b = react_1.useState(), open = _b[0], setOpen = _b[1];
    var keyTimerRef = react_1.useRef(null);
    react_1.useEffect(function () {
        return function () { return clearTimeout(keyTimerRef.current); };
    }, []);
    var keyUpHandler = function (e) {
        var name = e.currentTarget.name;
        var value = e.currentTarget.value;
        clearTimeout(keyTimerRef.current);
        keyTimerRef.current = setTimeout(function () {
            var _a;
            onEdit((_a = {}, _a[name] = value, _a));
        }, 500);
    };
    var newItemKeyUpHandler = function (e) {
        if (e.key === 'Escape') {
            setOpen(false);
            return;
        }
        if (e.key === 'Enter') {
            setOpen(false);
            if (e.currentTarget.value.length > 0)
                onSubmit(e.currentTarget.value);
        }
    };
    return (react_1.default.createElement("div", { className: 'edit-product-spec-items' },
        react_1.default.createElement("span", { className: 'title' }, "Items"),
        items.map(function (item) { return (react_1.default.createElement("div", { className: 'edit-product-spec-items__item flex flex-row flex-space-between', key: item.id },
            (editing === item.id) ?
                react_1.default.createElement("input", { type: 'text', name: 'name', placeholder: 'Type name then press Enter', defaultValue: item.name, onKeyUp: keyUpHandler, autoFocus: true })
                :
                    react_1.default.createElement("span", { className: 'name' }, item.name),
            react_1.default.createElement("div", { className: 'actions flex flex-row' },
                react_1.default.createElement("span", null,
                    "Featured on ",
                    item.count,
                    " product(s)"),
                react_1.default.createElement("button", { type: 'button', title: 'Edit Item', onClick: function () { return onSetEdit(item.id); }, "aria-selected": editing === item.id, className: 'actions__button-small' }, (editing === item.id) ?
                    react_1.default.createElement("img", { src: edit_icon_dark_svg_1.default, alt: 'Edit Item' })
                    :
                        react_1.default.createElement("img", { src: edit_icon_svg_1.default, alt: 'Edit Item' })),
                react_1.default.createElement("button", { type: 'button', title: 'Delete Item', onClick: function () { return onDelete(item); }, className: 'actions__button-small' },
                    react_1.default.createElement("img", { src: close_icon_svg_1.default, alt: 'Delete Item' }))))); }),
        !open &&
            react_1.default.createElement(AddButton_1.default, { label: 'Create new item', onClick: function () { return setOpen(true); } }),
        open &&
            react_1.default.createElement("div", { className: 'add-input' },
                react_1.default.createElement("input", { type: 'text', name: 'name', autoFocus: true, placeholder: 'Fill in name then press Enter', onKeyUp: newItemKeyUpHandler }))));
};
exports.default = EditProductSpecificationItems;
